// extracted by mini-css-extract-plugin
export var progressBar = "_fx-0";
export var progressBarInner = "_fx-1";